<template>
  <div>
    <mdb-chip :alt="user.name" @click.native="userClicked" :src="user.avatar" size="lg" waves>
      {{text ? text : user.name}}
    </mdb-chip>
  </div>
</template>

<script>
  import {mdbChip} from 'mdbvue';
  import {mapState} from "vuex";

  export default {
    name: 'UserChip',
    components: {
      mdbChip,
    },
    computed: mapState({
                         userDetails: state => state.userDetails,
                       }),
    props: {
      user: {
        type: Object,
        default: null
      },
      text: {
        type: String,
        default: null
      }
    },
    methods: {
      userClicked() {
        if (!this.userDetails.isAdmin) return
        //todo make a cool context menu to pick admin actions
        this.$router.push("/users/" + this.user.id + "/proxy")
      }
    }
  };
</script>

